import React from 'react';
import { Redirect } from 'react-router-dom';
import CreateEdit from '../views/createEdit';
import Layout from "./Layout";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from "@material-ui/core/Typography";
import PropTypes from 'prop-types';
import SubscriptionListing from "./SubscriptionListing";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(2)
      },
      heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6)
      },
      heroButtons: {
        marginTop: theme.spacing(4)
      },
      cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8)
      },
      card: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
      },
      cardMedia: {
        paddingTop: "56.25%" // 16:9
      },
      cardContent: {
        flexGrow: 1
      },
      footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6)
      },
      paperLeft: {
        width: "25%",
        float: "left",
        padding: "25px",
        marginRight: "25px"
      },
      paperRight: {
        width: "65%",
        float: "left",
        padding: "25px"
      }
  }));

  export default function Create() {
    
    
    const isAlreadyAuthenticated = localStorage.getItem('token');
    localStorage.setItem('SaveSubscription', 0);
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [subvalue, setsubValue] = React.useState(0);
    const handleChange = (event, newValue) => {
      setValue(newValue);      
      localStorage.setItem('profiletab', newValue); 
      localStorage.setItem('SaveSubscription', 0);
    
    };
  
    React.useEffect(() => {
      const tabactive = Number(localStorage.getItem("profiletab") || 0)
      setValue(tabactive);
    }, [])

        return (
            <Layout>
            <div>
                <main className="main-wrap">
                            <div className={classes.root}>
                                    <AppBar position="static"  color="default" className="header-wrap">
                                        <Tabs value={value} onChange={handleChange} indicatorColor="primary"
                                            textColor="primary"
                                            variant="scrollable"
                                            scrollButtons="auto">
                                            <Tab label="Profile" {...a11yProps(0)} />
                                            <Tab label="Subscription" {...a11yProps(1)} />
                                        </Tabs>
                                    </AppBar>
                                    <TabPanel value={value} index={0}>
                                        {isAlreadyAuthenticated ? <CreateEdit />: (<Redirect to={{ pathname: '/asd-login' }} />)}
                                    </TabPanel>
                                    <TabPanel value={value} index={1}><div><SubscriptionListing SelectedTab={value} /></div></TabPanel>

                            </div>
                    </main>
            </div>
            </Layout>
        );
    }

// export default Create;